import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  background-color: rgba(10, 25, 47, 0.85);
`;

const StyledModal = styled.div`
  width: 100%;
  max-width: 520px;
  border-radius: var(--border-radius);
  border: 1px solid var(--lightest-navy);
  background-color: var(--light-navy);
  color: var(--light-slate);
  box-shadow: 0 10px 30px -15px var(--navy-shadow);
  padding: 24px;

  .modal-header {
    ${({ theme }) => theme.mixins.flexBetween};
    margin-bottom: 10px;
  }

  .modal-title {
    margin: 0;
    color: var(--lightest-slate);
    font-size: var(--fz-xl);
  }

  .close-button {
    border: 0;
    background: transparent;
    color: var(--light-slate);
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    padding: 6px;
  }

  .modal-body {
    margin: 0 0 20px;
    font-size: 17px;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-start;
  }

  .cta {
    ${({ theme }) => theme.mixins.smallButton};
  }
`;

const NoticeModal = ({
  isOpen,
  onClose,
  title,
  message,
  actionLabel,
  actionHref,
  onActionClick,
}) => {
  if (!isOpen) {
    return null;
  }

  const modal = (
    <StyledOverlay onClick={onClose} role="presentation">
      <StyledModal
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={event => event.stopPropagation()}>
        <div className="modal-header">
          <h4 className="modal-title">{title}</h4>
          <button type="button" className="close-button" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        <p className="modal-body">{message}</p>
        <div className="modal-actions">
          {actionHref && (
            <a className="cta" href={actionHref} onClick={onActionClick}>
              {actionLabel}
            </a>
          )}
        </div>
      </StyledModal>
    </StyledOverlay>
  );

  if (typeof document === 'undefined') {
    return modal;
  }

  return createPortal(modal, document.body);
};

NoticeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  actionLabel: PropTypes.string,
  actionHref: PropTypes.string,
  onActionClick: PropTypes.func,
};

NoticeModal.defaultProps = {
  actionLabel: 'Send email',
  actionHref: '',
  onActionClick: () => {},
};

export default NoticeModal;
